<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentApp /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentApp from '@/components/team/dashboard/modules/activity/app/ContentApp.vue'

export default 
{
  name: 'App',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentApp
  }
}
</script>
<style>

</style>